/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum VestingTermPurchaseTermsType {
    PURCHASE_PRICE = 'PURCHASE_PRICE',
    FAIR_MARKET = 'FAIR_MARKET',
    LOWER_PRICE = 'LOWER_PRICE',
    HIGHER_PRICE = 'HIGHER_PRICE',
    PURCHASE_PRICE_DISCOUNT = 'PURCHASE_PRICE_DISCOUNT',
    FAIR_MARKET_DISCOUNT = 'FAIR_MARKET_DISCOUNT',
}
